/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import Button from "@alboompro/boom-components/general/button";
import Request from "shared/Request";
import { AnimatedCheck } from "./styles";

class PublishButton extends PureComponent {
  state = { requesting: false, requestJustEnded: false, minimalTime: 1100, blockButton: false };

  packPageContent = () => {
    const { page } = this.props;
    const { page_content } = page;
    const packedComponents = page.components.map((cmp) => {
      const { components, ...rest } = cmp;
      return rest;
    });
    return { ...page_content, components: packedComponents };
  };

  handlePublish = () => {
    const { minimalTime } = this.state;
    this.setState({ requesting: true, blockButton: true });
    setTimeout(() => { 
      const checkRequestStatus = setInterval(() => {
        const { requesting } = this.state;
        if (!requesting) {
          this.setState({ blockButton: false, requestJustEnded: true })
          setTimeout(() => { this.setState({ requestJustEnded: false }) }, 2800);
          clearInterval(checkRequestStatus);
        }
      }, 100);
    }, minimalTime);
    if (window.TextManager.isTextsSynced()) {
      this.publishRequest();
    } else {
      window.TextManager.syncAll().then(() => {
        this.publishRequest();
      });
    }
  };

  publishRequest() {
    const { page } = this.props;
    Request.put(
      `/custom-page/page_contents/${page.id}/${page.page_content._id}/publish`,
      {
        page_content: this.packPageContent(),
      }
    )
      .then(({ data }) => {
        console.log(data);
        this.setState({ requesting: false });
      })
      .catch((err) => {
        this.setState({ requesting: false });
        console.error("Falha ao publicar página");
      });
  }

  render() {
    const { requestJustEnded, blockButton } = this.state;

    return (
      <Button
        style={{
          backgroundColor: !requestJustEnded ? "#44ADF8" : '#5CBBAA',
          transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out',
          opacity: requestJustEnded && 1 
        }}
        textStyle={{ color: "#ffffff" }}
        onClick={this.handlePublish}
        loading={blockButton || requestJustEnded}
        loadingColor={requestJustEnded ? 'transparent' : '#ffffff'}
      >
        <AnimatedCheck success={requestJustEnded}>
          <svg viewBox='0 0 24 24'>
            <polyline points="18,7 11,16 6,12" />
          </svg>
        </AnimatedCheck>
        <span style={{ fontSize: 14 }}>{I18n.t("header.publish.button")}</span>
      </Button>
    );
  }
}

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({
  page: state.page,
});

export default connect(mapStateToProps, mapDispatchToProps)(PublishButton);
